import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';

@Component({
    components: {},
})
export default class SBSNSIcon extends Mixins(SBComponentVue) {

    @Prop({
        type: String,
        default: "",
    })
    public sns!: string;

    @Prop({
        type: String,
        default: "",
    })
    public url!: string;

    @Prop({
        type: String,
        default: "",
    })
    public name!: string;
}
